module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Regular.woff2
// module id = 1576
// module chunks = 57